import { combineReducers } from 'redux';
import viewer from './viewer';

export default combineReducers({
  viewer,
});
